import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  listHomeSections, addHomeSection, updateHomeSection, deleteHomeSection
} from "../services/homeSectionService";

const initial = {
  title: "",
  type: "row",           // row | featured | banner
  order: 100,
  active: true,
  query: { brandId: "", categoryId: "", limit: 10, sort: "new" },
  banner: { image: "", href: "/catalogue", alt: "" },
};

export default function HomeEditor() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(initial);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const list = await listHomeSections();
    setItems(list);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const handleChange = (path, value) => {
    setForm((f) => {
      const clone = JSON.parse(JSON.stringify(f));
      const keys = path.split(".");
      let cur = clone;
      for (let i=0; i<keys.length-1; i++) cur = cur[keys[i]];
      cur[keys.at(-1)] = value;
      return clone;
    });
  };

  const reset = () => { setForm(initial); setEditingId(null); };

  const submit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      if (editingId) {
        await updateHomeSection(editingId, form);
        toast.success("Section mise à jour");
      } else {
        await addHomeSection(form);
        toast.success("Section ajoutée");
      }
      reset();
      await load();
    } catch (err) {
      toast.error(err?.message || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  const onEdit = (it) => {
    setEditingId(it.id);
    setForm({
      title: it.title || "",
      type: it.type || "row",
      order: it.order ?? 100,
      active: !!it.active,
      query: { brandId: it.query?.brandId || "", categoryId: it.query?.categoryId || "", limit: it.query?.limit || 10, sort: it.query?.sort || "new" },
      banner: { image: it.banner?.image || "", href: it.banner?.href || "/catalogue", alt: it.banner?.alt || "" },
    });
  };

  const onDelete = async (id) => {
    if (!window.confirm("Supprimer cette section ?")) return;
    await deleteHomeSection(id);
    toast.success("Section supprimée");
    await load();
  };

  return (
    <div className="container py-4">
      <div className="row g-4">
        <div className="col-lg-5">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="mb-3">{editingId ? "Modifier la section" : "Nouvelle section"}</h5>
              <form onSubmit={submit} className="vstack gap-3">
                <div>
                  <label className="form-label">Titre</label>
                  <input className="form-control" value={form.title} onChange={e=>handleChange("title", e.target.value)} required />
                </div>

                <div className="row g-2">
                  <div className="col-md-4">
                    <label className="form-label">Type</label>
                    <select className="form-select" value={form.type} onChange={e=>handleChange("type", e.target.value)}>
                      <option value="row">Ligne (grille)</option>
                      <option value="featured">Mise en avant (1+4)</option>
                      <option value="banner">Bannière</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Ordre</label>
                    <input type="number" className="form-control" value={form.order} onChange={e=>handleChange("order", Number(e.target.value))} />
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <div className="form-check">
                      <input id="active" className="form-check-input" type="checkbox" checked={form.active} onChange={e=>handleChange("active", e.target.checked)} />
                      <label className="form-check-label" htmlFor="active">Active</label>
                    </div>
                  </div>
                </div>

                {form.type !== "banner" ? (
                  <>
                    <div className="row g-2">
                      <div className="col-md-6">
                        <label className="form-label">Marque (optionnel)</label>
                        <input className="form-control" placeholder="brandId" value={form.query.brandId} onChange={e=>handleChange("query.brandId", e.target.value)} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Catégorie (optionnel)</label>
                        <input className="form-control" placeholder="categoryId" value={form.query.categoryId} onChange={e=>handleChange("query.categoryId", e.target.value)} />
                      </div>
                    </div>
                    <div className="row g-2">
                      <div className="col-md-6">
                        <label className="form-label">Taille (limit)</label>
                        <input type="number" min={1} max={30} className="form-control" value={form.query.limit} onChange={e=>handleChange("query.limit", Number(e.target.value))} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Tri</label>
                        <select className="form-select" value={form.query.sort} onChange={e=>handleChange("query.sort", e.target.value)}>
                          <option value="new">Nouveautés</option>
                          <option value="price_asc">Prix ↑</option>
                          <option value="price_desc">Prix ↓</option>
                        </select>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <label className="form-label">Image (URL)</label>
                      <input className="form-control" value={form.banner.image} onChange={e=>handleChange("banner.image", e.target.value)} required />
                    </div>
                    <div className="row g-2">
                      <div className="col-md-8">
                        <label className="form-label">Lien</label>
                        <input className="form-control" value={form.banner.href} onChange={e=>handleChange("banner.href", e.target.value)} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Alt</label>
                        <input className="form-control" value={form.banner.alt} onChange={e=>handleChange("banner.alt", e.target.value)} />
                      </div>
                    </div>
                  </>
                )}

                <div className="d-grid">
                  <button className="btn btn-success" disabled={saving}>
                    {saving ? "Enregistrement..." : (editingId ? "Mettre à jour" : "Ajouter la section")}
                  </button>
                </div>
                {editingId && (
                  <button type="button" className="btn btn-outline-secondary" onClick={reset}>Annuler</button>
                )}
              </form>
            </div>
          </div>
        </div>

        <div className="col-lg-7">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="m-0">Sections d’accueil</h5>
                <button className="btn btn-sm btn-outline-secondary" onClick={load} disabled={loading}>Rafraîchir</button>
              </div>

              <div className="table-responsive">
                <table className="table align-middle">
                  <thead>
                    <tr>
                      <th>Ordre</th>
                      <th>Titre</th>
                      <th>Type</th>
                      <th>Actif</th>
                      <th>Query</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map(it => (
                      <tr key={it.id}>
                        <td>{it.order}</td>
                        <td>{it.title}</td>
                        <td><span className="badge text-bg-light">{it.type}</span></td>
                        <td>{it.active ? "✅" : "—"}</td>
                        <td className="small text-muted">
                          {it.type !== "banner"
                            ? `brand:${it.query?.brandId || "-"} cat:${it.query?.categoryId || "-"} limit:${it.query?.limit || 10} sort:${it.query?.sort || "new"}`
                            : `banner: ${it.banner?.href || "-"}`}
                        </td>
                        <td className="text-end">
                          <div className="btn-group">
                            <button className="btn btn-sm btn-outline-primary" onClick={() => onEdit(it)}>Éditer</button>
                            <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(it.id)}>Supprimer</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {items.length === 0 && !loading && (
                      <tr><td colSpan={6} className="text-muted">Aucune section.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
